import script from "./PhotoUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoUploader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QFile,QIcon,QSpinner,QSkeleton,QImg});
